import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import classNames from 'classnames';
import formatPhoneNumber from '../../../common/helpers/formatPhoneNumber';
import {
  canUserModifyCustomers,
  canUserViewAppointmentContactInfo,
  fullName,
  isSignedUpCustomer,
} from '../../../common/helpers/users';
import Icon, { GLYPHS } from '../../../common/icon';
import combinationImage from '../../../../../images/combination-lock.png';
import withPermissions from '../../../auth/utils/withPermissions';
import { maskEmail, maskPhoneNumber } from '../../../common/helpers/mask';

const CustomersListItem = ({ customer, userUrlPrefix, permissions }) => {
  const { id, email, phone, photos } = customer;
  const detailsUrl = `${userUrlPrefix}/customers/${id}`;

  let avatar;
  let lock = null;

  const canUserViewContactInfo = canUserViewAppointmentContactInfo(permissions);

  if (photos && photos.length > 0) {
    avatar = (
      <img
        className="c-avatar-image"
        src={photos[0].thumbnail}
        role="presentation"
      />
    );
  } else {
    avatar = (
      <Icon glyph={GLYPHS.customers} size="medium" />
    );
  }

  if (isSignedUpCustomer(customer)) {
    lock = (<img src={combinationImage} role="presentation" />);
  }

  const linkClass = classNames(
    'c-table-card__row',
    { 'no-pointer-events': !canUserModifyCustomers(permissions) },
  );

  return (
    <Link key={id} className={linkClass} to={detailsUrl}>
      <div className="c-table-card__cell u-3/10">
        <div className="u-text-trim">
          <span className="c-avatar u-mr--">{ avatar }</span>
          <span>{ fullName(customer) }</span>
          { lock }
        </div>
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-3/10">
        <div className="u-text-trim">{ canUserViewContactInfo ? email : maskEmail(email) }</div>
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-2/10">
        <div className="u-text-trim">
          { canUserViewContactInfo ? formatPhoneNumber(phone) : maskPhoneNumber(phone) }
        </div>
      </div>
    </Link>
  );
};

CustomersListItem.propTypes = {
  customer: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  userUrlPrefix: PropTypes.string.isRequired,
};

export default withPermissions(CustomersListItem);
